module.exports = __webpack_public_path__ + "static/media/AmilaR.ebd0c344.jpg";